import { isIntervalMeterSourceI18nKey } from "@/services/interval"
import { getDisplayValue } from "@/utils/value"

export const formatIntervalMeterSource = (
  source: string | undefined,
  translatedKey: (key: string) => string
): string => {
  if (source && isIntervalMeterSourceI18nKey(source)) {
    return translatedKey(source)
  }

  return getDisplayValue(source)
}
